import React from "react"
import { BottomNavigation, BottomNavigationAction, Hidden } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { NavLink, useLocation } from "react-router-dom"
import { useAuth } from "../../services"
import { useQuerySettings } from "../../data"
import { Icon } from ".."
import { RequirePermissions } from "../Permissions"

const useMobileNavStyles = makeStyles(() => ({
  root: {
    position: "fixed",
    zIndex: 1000,
    bottom: 0,
    width: "100%",
    backgroundColor: "white",
    height: 65,
    paddingTop: 5,
    alignItems: "center",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
  },
}))

const useMobileNavActionStyles = makeStyles(() => ({
  root: {
    padding: "6px 0 !important",
    margin: 0,
    alignItems: "center",
    minWidth: "auto",
  },
  wrapper: {
    height: 51,
  },
  iconOnly: {
    paddingTop: 0,
  },
  selected: {
    background: "linear-gradient(to right, #f63b3b, #fd9317) left bottom no-repeat",
    backgroundSize: "100% 5px",
  },
}))

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 38,
    color: "black",
  },
  moreIcon: {
    height: 29,
    width: 29,
    color: "#141333",
  },
}))

const MobileBottomNav = () => {
  const classes = useStyles()
  const mobileNavClasses = useMobileNavStyles()
  const mobileNavActionClasses = useMobileNavActionStyles()
  const location = useLocation()
  // const { hasPermission } = useAuth()
  const {
    authed,
    permissionGroups: { readJobs, readKnowledge, readTemplates },
    location: userLocation,
  } = useAuth()
  const settings = useQuerySettings()
  // const [more, setMore] = useState(false)

  if (!authed) return null

  // const handleToggleMore = () => setMore(!more)

  const renderItem = (label, area, to, disabled = false, requires, operator = "or") => {
    const item = (
      <BottomNavigationAction
        label={label}
        showLabel
        to={`/${to}`}
        icon={<Icon name={area} className={classes.icon} />}
        classes={mobileNavActionClasses}
        selected={location.pathname.startsWith(`/${area}`)}
        value={area}
        component={NavLink}
        style={{ opacity: disabled ? 0.3 : 1 }}
        disabled={disabled}
      />
    )

    return requires ? (
      <RequirePermissions requires={requires} operator={operator}>
        {item}
      </RequirePermissions>
    ) : (
      item
    )
  }

  // const NavItem = ({ to, text, ...rest }) => (
  //   <SubNavigationListItem to={to} text={text} onClick={() => handleToggleMore()} {...rest} />
  // )

  const currentArea = location.pathname.length > 1 ? location.pathname.split("/")[1] : "dashboard"

  return (
    <>
      {authed && (
        <>
          {/* <Drawer open={more} onClose={handleToggleMore}>
            <List>
              {hasPermission("user_read_admin") && <NavItem to="/people" text={settings.lang.area.people} />}
              {hasPermission(readTemplates) && <NavItem to="/templates" text={settings.lang.area.templates} />}
              {hasPermission("sensor_read") && <NavItem to="/sensors" text={settings.lang.area.sensors} beta />}
              {hasPermission("user_read_admin") && <NavItem to="/reports" text={settings.lang.area.reports} beta />}
            </List>
          </Drawer> */}
          <Hidden smUp>
            <BottomNavigation classes={mobileNavClasses} value={currentArea} showLabels={false}>
              {renderItem(settings.lang.areaShort.dashboard, "dashboard", "dashboard", !userLocation)}
              {renderItem(settings.lang.areaShort.jobs, "jobs", "jobs", !userLocation, readJobs)}
              {renderItem(settings.lang.areaShort.knowledge, "knowledge", "knowledge", false, readKnowledge)}
              {renderItem(settings.lang.areaShort.hub, "hub", "hub", !userLocation, "post_read")}
              {/* <BottomNavigationAction
                label="More"
                showLabel
                icon={<Icon name="more" className={classes.moreIcon} />}
                classes={mobileNavActionClasses}
                selected={false}
                value="more"
                disabled={false}
                onClick={handleToggleMore}
              /> */}
              {renderItem(
                settings.lang.areaShort.templates,
                "templates",
                "templates/active-recurring",
                !userLocation,
                readTemplates
              )}
            </BottomNavigation>
          </Hidden>
        </>
      )}
    </>
  )
}

export default MobileBottomNav
